import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import '../components/AboutUs.css'; // Applying consistent styles
const Careers = () => {
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        const storedJobs = JSON.parse(localStorage.getItem("adminJobs")) || [];
        setJobs(storedJobs);
    }, []);

    return (
        <div className="careers-page">
            <section className="hero-section-careers">
                <h1 className="hero-title">Join Our Team</h1>
                <p className="hero-subtitle">Explore exciting opportunities and grow your career with us.</p>
            </section>

            <div className="container mx-auto py-10 px-4">
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h2 className="text-2xl font-semibold mb-6 text-center">Current Openings</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg text-left bg-white shadow-md">
                            <thead className="bg-gray-100 text-gray-700">
                                <tr>
                                    <th className="border p-3 font-semibold">Job Title</th>
                                    <th className="border p-3 font-semibold">Location</th>
                                    <th className="border p-3 font-semibold">Department</th>
                                    <th className="border p-3 font-semibold">Job Type</th>
                                    <th className="border p-3 font-semibold">Posted Date</th>
                                    <th className="border p-3 font-semibold">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobs.length > 0 ? (
                                    jobs.map((job) => (
                                        <tr key={job.id} className="border hover:bg-gray-50">
                                            <td className="border p-3 font-medium text-blue-900">
                                                <Link to={`/careers/${job.id}`} className="hover:underline">
                                                    {job.title}
                                                </Link>
                                            </td>
                                            <td className="border p-3">{job.location}</td>
                                            <td className="border p-3">{job.department}</td>
                                            <td className="border p-3">{job.jobType}</td>
                                            <td className="border p-3">{job.postedDate}</td>
                                            <td className="border p-3 text-center">
                                                <Link to={`/careers/${job.id}`} className="text-blue-600 font-semibold hover:underline">
                                                    View Details
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center p-4 text-gray-500">No job openings available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Careers;
